<!-- <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<h3>Forgot Password?</h3>
<a [routerLink]="'/login'">Go Back To Login Page</a>
<p>If you have associated your email address with your ignite humans account, you may reset your password here.</p>
<input type="text" [(ngModel)]="email" placeholder="Email Address" />
<button mat-button (click)="getResetEmail()">Receive Email</button> -->

<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<!-- <div class="loginPage">
  <div class="logo">
    <img src="../../assets/images/new_logo.svg" alt="" class="logoImg" />
  </div>
  <h3>Forgot Password?</h3>
  <div class="input-box-wrapper">
    <p>If you login with an email address, please type it here</p>
    <div class="userName">
      <input type="text" [(ngModel)]="email" placeholder="Email Address" />
    </div>
    <div class="loginBtn" (click)="getResetEmail()">Receive Email</div>
  </div>
  <p style="margin-bottom: 10px;">If you login with your employee code (not an email) please contact your Company Admin for your generic password</p>
  <a [routerLink]="'/login'">Go Back To Login Page</a>
</div> -->






<div class="forget-box">
  <div class="inner-box">
    <div class="logo">
      <img src="../../../../../assets/images/Ignite Logo Black Transparent-PhotoRoom.png" alt="" />
    </div>

    <div class="input-box">
      <label>Email Address</label>
      <input type="text" [(ngModel)]="email" />
    </div>

    <p>
      <strong>IMPORTANT:</strong> If you login with your employee code <strong>(not an
      email)</strong>  could  you  please  contact  your  Company  Admin  for
      your generic password, as your IGNITE account is not linked
      to an email address. Thanks so much!
    </p>

    <div class="reset-btn-box">
      <button (click)="getResetEmail()" mat-raised-button>Submit</button>
    </div>

    <div class="login-route-link">
      <a [routerLink]="'/login'">Take me back to my login</a>
    </div>
  </div>
</div>
